import { Component, isDevMode, OnDestroy, OnInit } from '@angular/core';
import {CentreService} from "../../../../services/centre.service";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {ChildService} from "../../../../components/child/child.service";
import {Observable, Subject} from "rxjs";
import {map, takeUntil} from "rxjs/operators";
import {Centre} from "../../../../interfaces/Centres";
import {FullChild} from "../../../../interfaces/FullChild";
import {environment} from "../../../../../environments/environment";

@Component({
  selector: 'app-follow-up',
  templateUrl: './follow-up.component.html',
  styleUrls: ['./follow-up.component.scss']
})
export class FollowUpComponent implements OnInit, OnDestroy {
  env = isDevMode() ? environment.testMode : environment.productionMode;
  private _destroyed$ = new Subject<void>();
  centres$: Observable<Centre[]>;
  selectedCentre="All";
  selectedChildCode?: any;
  childBycentre: Observable<FullChild[]> | undefined;
  ChildData: any[] | undefined;
  constructor(private mCentreService: CentreService,
              private mFirestore: AngularFirestore,
              private childService: ChildService,) {
    this.centres$ = this.mCentreService.getAllCentres().pipe(
      map(centres => [...centres].sort((a, b) => (a.centreName ?? '').trim().localeCompare((b.centreName ?? '').trim())))
    );

  }

  ngOnInit(): void {

  }
  search() {
    if (this.selectedCentre != null) {
      this.childBycentre = this.childService.getAllotedChildListByCenter(this.selectedCentre!)
    }
  }

  searchChild() {
    let childObject = {

      'childCode': this.selectedChildCode.childCode,
      'childName': this.selectedChildCode.firstName + ' ' + this.selectedChildCode.lastName,
      'parentsName': this.selectedChildCode.guardians[0]?.firstName + 'and ' + this.selectedChildCode.guardians[1]?.firstName,

    }

    this.mFirestore.collection(this.env.child, ref =>ref.where('centreCode', '==', this.selectedCentre)
      .where('childCode', '==', childObject.childCode)).valueChanges().pipe(takeUntil(this._destroyed$)).subscribe(res => {
        this.ChildData = res
      console.log(this.ChildData)
    })

  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
